<template>
  <div id="app">
    <Header :showLinks="showLinks" />

    <slot />

    <Footer />
  </div>
</template>

<script>
import "../../icons/";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { localizedLink, orgConfig, orgConfiguration } from "@/mixins";

export default {
  mixins: [localizedLink, orgConfig],
  components: {
    Header,
    Footer
  },
  props: {
    showLinks: {
      type: Boolean,
      default: () => true
    }
  },
  metaInfo() {
    if (!this.showLinks) {
      return {
        title: this.$t("portal"),
        titleTemplate: "%s - by Apitalks!",
        meta: [
          {
            vmid: "description",
            name: "description",
            content: this.$t("description")
          },
          {
            vmid: "twitter:description",
            name: "twitter:description",
            content: this.$t("description")
          },
          {
            vmid: "twitter:card",
            name: "twitter:card",
            content: "summary_large_image"
          }
        ]
      };
    }
    return {
      title:
        this.$t("portal") +
        " " +
        orgConfiguration(this.organizationConfig, "organization.name"),
      titleTemplate: "%s - by Apitalks!",
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.$t("description")
        },
        {
          vmid: "twitter:description",
          name: "twitter:description",
          content: this.$t("description")
        },
        {
          vmid: "twitter:card",
          name: "twitter:card",
          content: "summary_large_image"
        },
        {
          vmid: "twitter:url",
          name: "twitter:url",
          content: orgConfiguration(this.organizationConfig, "organization.url")
        },
        {
          vmid: "twitter:title",
          name: "twitter:title",
          content:
            this.$t("portal") +
            orgConfiguration(this.organizationConfig, "organization.name")
        },
        {
          vmid: "twitter:image",
          name: "twitter:image",
          content: `${
            process.env.VUE_APP_PORTAL_PATH
          }/../tamplete/dev-portal.png`
        },
        {
          vmid: "og:title",
          property: "og:title",
          content:
            this.$t("portal") +
            orgConfiguration(this.organizationConfig, "organization.name")
        },
        { vmid: "og:type", property: "og:type", content: "website" },
        {
          vmid: "og:description",
          property: "og:description",
          content: this.$t("description")
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: orgConfiguration(this.organizationConfig, "organization.url")
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: `${
            process.env.VUE_APP_PORTAL_PATH
          }/../tamplete/dev-portal.png`
        }
      ],
      htmlAttrs: {
        lang: this.$i18n.locale
      }
    };
  }
};
</script>
